import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { LinkItemDto } from "../../entities/processCycle/LinkItemDto";
import { TaskDto } from "../../entities/processCycle/TaskDto";
import { AppDispatch, AppState } from "../../store/configureStore";
import { rejectTask } from "../../store/slices/candidateProcesses";
import { useAddComment } from "../UI/AddCommentComponent";
import FileDownloadButton from "../UI/FileDownloadButton";
import { getFileNameFromBlobUrl } from "../UI/FileDownloadComponent";
import { useMessageBox } from "../UI/MessageBoxComponent";
import { useEffect, useState } from "react";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getSigningProcessStatus, startSigningProcessStatusPoll } from "store/slices/tasks";
import { SigningTaskStatus } from "entities/SigningTaskStatus";

interface Props {
    task: TaskDto,
}

function ContractSigningCard({ task }: Props) {
    const { t } = useTranslation("candidate_portal");
    const dispatch = useDispatch<AppDispatch>();
    const { showAddComment, AddCommentComponent } = useAddComment();
    const { showMessageBox, MessageBoxComponent } = useMessageBox();
    const [isSigning, setIsSigning] = useState(false);
     const { data: signingTaskStatus, loading: signingTaskStatusLoading } = useSelector((state: AppState) => state.entities.tasks.signingTaskStatus);

    
    const TASK_STATUS_REJECTED = 2;
    const TASK_STATUS_COMPLETED = 1;

    const isRejected = task.Status === TASK_STATUS_REJECTED;
    const isCompleted = task.Status === TASK_STATUS_COMPLETED;
    const isActionable = !isRejected && !isCompleted;

    useEffect(() => {
        let intervalId: NodeJS.Timeout;

        if (isSigning && task) {
            const taskStatus = async () => {
                try {
                    const result = (await dispatch(getSigningProcessStatus(task.Id)));
                } catch (error) {
                    console.error("Error polling signing status:", error);
                }
            };

            intervalId = setInterval(taskStatus, 10000); // Poll every 10 seconds
        };

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            };
        };
    }, [isSigning, task, dispatch]);

        useEffect(() => {
        if (!signingTaskStatusLoading && signingTaskStatus && task) {
            if (signingTaskStatus === SigningTaskStatus.Completed || signingTaskStatus === SigningTaskStatus.Rejected) {
                setIsSigning(false);
            }
        };
    }, [signingTaskStatus, task, signingTaskStatusLoading]);

    const handleReject = async () => {
        const comment = await showAddComment(t("jobOffer.commentTitle"));
        if (comment) {
            dispatch(rejectTask(task.Id, comment));
        }
    };

    const handleApprove = () => {
        if (task.Link && task.SigningProcessGuid) {
            setIsSigning(true);
            window.open(task.Link, "_blank");
            dispatch(startSigningProcessStatusPoll(task.Id));
        } else {
            showMessageBox(t("pages:pageNotFound.heading"), t("contract.noSigningUrl"));
        }
    };

    const mainLink = task.Link || "";
    const mainLinkId = task.LinkId || 0;

    const hasLink = !!mainLink;

    return (
        <>
            {/* Full screen overlay to block things while Signing goes on */}
            {isSigning && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    color: 'white',
                    zIndex: 9999,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <FontAwesomeIcon icon={faSpinner} size="3x" spin className="mb-3" />
                    <h3>{t("pages:workflows.detailModal.signingInProgress")}</h3>
                    <p>{t("pages:workflows.detailModal.signInAnotherTab")}</p>
                    <Button variant="light" className="mt-4" onClick={() => setIsSigning(false)}>{t("common:form.buttons.cancel")}</Button>
                </div>
            )}

            {/* {hasLink && (
                <FileDownloadButton
                    fileName={getFileNameFromBlobUrl(mainLink)}
                    fileRefId={mainLinkId}
                    disabled={!hasLink}
                    classNameBtn="big circular-button edit-button outline-none p-0"
                    onChange={(success, error) =>
                        console.log("fileDownload", success, error)
                    }
                    className="main-file-download-button"
                />
            )} */}

            {((task.Files && task.Files.length > 0) || (task.Links && task.Links.length > 0)) ? (
                <div>
                    <div className="card-subtitle mb-2">{t("contract.documents")}</div>
                    {
                        task.Files && task.Files.length > 0 && task.Files.map((link: LinkItemDto, index: number) => (
                            <FileDownloadButton
                                key={link.Id}
                                fileName={link.Url}
                                fileRefId={link.Id}
                                classNameBtn="btn border-0 p-0 active-color font-input-full"
                                onChange={(success, error) =>
                                    console.log("fileDownload", success, error)
                                }
                                className="mb-1"
                                icon={
                                    <div>{link.Text}</div>
                                }
                            />
                        ))
                    }
                    {
                        task.Links && task.Links.length > 0 && task.Links.map((link: LinkItemDto, index: number) => (
                            <a
                                key={link.Id}
                                href={link.Url}
                                download={link.Text}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mb-1 btn border-0 p-0 active-color font-input-full"
                            >
                                <div>{link.Text}</div>
                            </a>
                        ))
                    }
                    <div className="agreement mt-2">{t("contract.agreement")}</div>
                </div>
            ) : null}

            {/* {hasLink && (
                <div>
                    <div className="card-subtitle mb-2">
                        {t("contract.contractSinging")}
                    </div>
                    <FileDownloadButton
                        fileName={getFileNameFromBlobUrl(mainLink)}
                        fileRefId={mainLinkId}
                        disabled={!hasLink}
                        classNameBtn="btn border-0 p-0 active-color font-input-full"
                        onChange={(success, error) =>
                            console.log("fileDownload agreeStatus", success, error)
                        }
                        className="mb-2"
                        icon={
                            <div>{getFileNameFromBlobUrl(mainLink)}</div>
                        }
                    />
                </div>
            )} */}

            {isActionable && (
                <div>
                    <Button variant="primary" onClick={handleApprove} disabled={!hasLink} className="visual-selection-aid">
                        {t("contract.agree")}
                    </Button>
                    <Button variant="outline-active" className="ms-5 visual-selection-aid" onClick={handleReject}>
                        {t("contract.disagree")}
                </Button>
            </div>)}
            
            {isCompleted && (
                <div className="mt-3 p-3 bg-light">
                    <strong>✓ {t("contract.signedStatus")}</strong>
                    {task.SenderComment && (<div className="mt-2 small">{task.SenderComment}</div>)}
                </div>
            )}
            {isRejected && (
                <div>
                    <strong>✗ {t("contract.rejectStatus")}</strong>
                    {task.SenderComment && (<div className="mt-2 small">{t("reason")}: {task.SenderComment}</div>)}
                </div>
            )}

            <MessageBoxComponent />
            <AddCommentComponent />
        </>
    );
}

export default ContractSigningCard;